import { useContext } from 'react';
import FeaturesContext, { Features, FeaturesContextType } from 'context/FeaturesContext';
import { CheckFeatureFunction } from './types';

const useCheckFeatures = (): [Features, (enabler: string) => boolean] => {
  const { features } = useContext<FeaturesContextType>(FeaturesContext);
  const enabledFeatures = Object.entries(features)
    .filter(keyValuePair => keyValuePair[1])
    .map(keyValuePair => keyValuePair[0]);

  const checkFeature: CheckFeatureFunction = enabler => enabledFeatures.includes(enabler);

  return [features, checkFeature] as const;
};

export default useCheckFeatures;
